import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Phone, AlertTriangle, Hospital, ShieldAlert, Flame } from 'lucide-react';
import styles from './Emergency.module.css';
import api from '../../api/axios';

const Emergency = () => {
  const [triggering, setTriggering] = useState(false);
  const [purpose, setPurpose] = useState('');
  const contacts = [
    { title: 'Police Station', number: '100', icon: ShieldAlert, type: 'police' },
    { title: 'Fire Brigade', number: '101', icon: Flame, type: 'fire' },
    { title: 'Ambulance / Hospital', number: '102', icon: Hospital, type: 'medical' },
    { title: 'Society Manager', number: '+91 99209 09082', icon: Phone, type: 'management' },
    { title: 'Lift Technician', number: '+91 00000 00000', icon: Phone, type: 'maintenance' }
  ];

  const handleTriggerPanicAlarm = async () => {
    if (triggering) return;
    try {
      setTriggering(true);
      await api.post('/security/panic-alarm', { purpose });
      toast.error("PANIC ALARM BROADCASTED! All residents notified.", {
        duration: 5000,
        icon: <AlertTriangle size={20} color="#fff" />,
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to trigger panic alarm");
    } finally {
      setTriggering(false);
      setPurpose('');
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <div>
          <h1>Emergency Contacts</h1>
          <p>Quick access to emergency services and society management</p>
        </div>
      </div>

      <div className={styles.panicSection}>
        <button 
          className={styles.panicBtn} 
          onClick={handleTriggerPanicAlarm}
          disabled={triggering}
          style={{ opacity: triggering ? 0.7 : 1, cursor: triggering ? 'not-allowed' : 'pointer' }}
        >
          <AlertTriangle size={32} />
          <span>{triggering ? 'BROADCASTING ALARM...' : 'TRIGGER PANIC ALARM'}</span>
        </button>
        <input 
          type="text" 
          placeholder="Optional: Enter purpose (e.g., Fire, Medical, Fight)" 
          value={purpose}
          onChange={(e) => setPurpose(e.target.value)}
          className={styles.purposeInput}
        />
        <p>Use only in case of severe emergencies (Fire, Security Breach, Medical).</p>
      </div>

      <div className={styles.grid}>
        {contacts.map((contact, index) => {
          const Icon = contact.icon;
          return (
            <div key={index} className={styles.contactCard}>
              <div className={`${styles.iconWrapper} ${styles[contact.type]}`}>
                <Icon size={24} />
              </div>
              <div className={styles.info}>
                <h3>{contact.title}</h3>
                <h2>{contact.number}</h2>
              </div>
              <button className={styles.callBtn} title="Call Now">
                <Phone size={20} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Emergency;
